import { render, staticRenderFns } from "./RequestMoreInfo.vue?vue&type=template&id=a2c160d0&"
import script from "./RequestMoreInfo.vue?vue&type=script&lang=ts&"
export * from "./RequestMoreInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports